spec_version: '1.1'
id: 6
slug: 06-optimizacion-fiscal
titulo: Optimización fiscal
duracion_min: 120
estado: placeholder
fase_produccion: 0
ultima_actualizacion: '2026-06-15'
prerrequisitos: []
objetivos_aprendizaje:
- id: OA-06.1
  texto: Identificar los vehículos fiscalmente eficientes según tu situación
  bloom: ''
- id: OA-06.2
  texto: Aprovechar deducciones aplicables sin caer en optimización contraproducente
  bloom: ''
- id: OA-06.3
  texto: Planificar a largo plazo con foco en la fiscalidad agregada
  bloom: ''
glosario: []
secciones:
- tipo: teoria
  archivo: teoria.md
- tipo: quiz-practica
  archivo: quiz-practica.md
- tipo: recursos
  archivo: recursos.md
sub_secciones_teoria:
- id: '6.1'
  titulo: El IRPF y cómo tributan las inversiones
  duracion_min: 20
- id: '6.2'
  titulo: Deducciones autonómicas y estatales
  duracion_min: 15
- id: '6.3'
  titulo: Planes de pensiones y EPSV
  duracion_min: 20
- id: '6.4'
  titulo: Cuentas-vivienda y otras figuras
  duracion_min: 15
- id: '6.5'
  titulo: 'Traspasos entre fondos: por qué importan'
  duracion_min: 20
- id: '6.6'
  titulo: 'Declaración de la renta: errores comunes'
  duracion_min: 15
- id: '6.7'
  titulo: Planificación fiscal a 10+ años
  duracion_min: 15
